import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from "./components/App";
// import Loadable from "react-loadable";
import loadable from "@loadable/component";

import Loading from "./components/helpers/loading";
import React from "react";
import { createRoot } from 'react-dom/client';
import Root from "./Root";
import withTracker from "./withTracker";
import withRouter from "./withRouter";
import Home from "./components/Mobile/Home";
// import Player from "./components/Mobile/Location";
// const Player = withTracker(loadable(() => import("./components/Mobile/Player"), {
//     fallback: <Loading />,
// }));

const IFrame = withTracker(loadable(() => import("./components/Iframe"), {
    fallback: <Loading />,
}));

const NotFound = withTracker(loadable(() => import("./components/NotFound"), {
    fallback: <Loading />,
}));

const Location = withTracker(loadable(() => import("./components/Mobile/Location"), {
    fallback: <Loading />,
}));

const Items = withTracker(loadable(() => import("./components/Mobile/Items"), {
    fallback: <Loading />,
}));

const Login = withTracker(loadable(() => import("./components/Mobile/Auth"), {
    fallback: <Loading />,
}));

const Register = withTracker(loadable(() => import("./components/Mobile/Auth/Register"), {
    fallback: <Loading />,
}));

const CartPage = withTracker(loadable(() => import("./components/Mobile/Cart"), {
    fallback: <Loading />,
}));

const MyCarts = withTracker(loadable(() => import("./components/Mobile/SavedCarts"), {
    fallback: <Loading />,
}));

const Account = withTracker(loadable(() => import("./components/Mobile/Account"), {
    fallback: <Loading />,
}));

const Explore = withTracker(loadable(() => import("./components/Mobile/Explore"), {
    fallback: <Loading />,
}));

const Addresses = withTracker(loadable(() => import("./components/Mobile/Account/Addresses"), {
    fallback: <Loading />,
}));

const Cards = withTracker(loadable(() => import("./components/Mobile/Account/Cards"), {
    fallback: <Loading />,
}));

const Checkout = withTracker(loadable(() => import("./components/Mobile/Checkout"), {
    fallback: <Loading />,
}));

const RunningOrder = withTracker(loadable(() => import("./components/Mobile/RunningOrder"), {
    fallback: <Loading />,
}));

const Orders = withTracker(loadable(() => import("./components/Mobile/Account/Orders"), {
    fallback: <Loading />,
}));

const WalletPage = withTracker(loadable(() => import("./components/Mobile/Account/Wallet"), {
    fallback: <Loading />,
}));

const Delivery = withTracker(loadable(() => import("./components/Delivery"), {
    fallback: <Loading />,
}));

const DeliveryLogin = withTracker(loadable(() => import("./components/Delivery/Login"), {
    fallback: <Loading />,
}));

const POS = withTracker(loadable(() => import("./components/POS"), {
    fallback: <Loading />,
}));

const BookTable = withTracker(loadable(() => import("./components/Mobile/BookTable"), {
    fallback: <Loading />,
}));

const TableLanding = withTracker(loadable(() => import("./components/Mobile/TableLanding"), {
    fallback: <Loading />,
}));

const DeliveryOrders = withTracker(loadable(() => import("./components/Delivery/Orders"), {
    fallback: <Loading />,
}));

const ViewOrder = withTracker(loadable(() => import("./components/Delivery/ViewOrder"), {
    fallback: <Loading />,
}));

const GeoLocationPage = withTracker(loadable(() => import("./components/Mobile/GeoLocationPage"), {
    fallback: <Loading />,
}));

const CreditCardPage = withTracker(loadable(() => import("./components/Mobile/CreditCardPage"), {
    fallback: <Loading />,
}));

const SingleItem = withTracker(loadable(() => import("./components/Mobile/Items/SingleItem"), {
    fallback: <Loading />,
}));

const ItemsParent = withTracker(loadable(() => import("./components/Mobile/Items/ItemsParent"), {
    fallback: <Loading />,
}));

const SingleItemParent = withTracker(loadable(() => import("./components/Mobile/Items/SingleItemParent"), {
    fallback: <Loading />,
}));

const SinglePage = withTracker(loadable(() => import("./components/SinglePage"), {
    fallback: <Loading />,
}));

const ForgotPassword = withTracker(loadable(() => import("./components/Mobile/Auth/ForgotPassword"), {
    fallback: <Loading />,
}));

const RestaurantListOnCategory = withRouter(withTracker(loadable(() => import("./components/Mobile/Home/RestaurantListOnCategory"), {
    fallback: <Loading />,
})));

const RatingAndReview = withTracker(loadable(() => import("./components/Mobile/Account/Orders/RatingAndReview"), {
    fallback: <Loading />,
}));

const ViewStoreReviews = withTracker(loadable(() => import("./components/Mobile/StoreReviews"), {
    fallback: <Loading />,
}));

const Alerts = withTracker(loadable(() => import("./components/Mobile/Alerts"), {
    fallback: <Loading />,
}));

const FavoriteRestaurantList = withTracker(loadable(() => import("./components/Mobile/Home/FavoriteRestaurants"), {
    fallback: <Loading />,
}));

const LoginAsCustomer = withTracker(loadable(() => import("./components/Mobile/Modules/LoginAsCustomer"), {
    fallback: <Loading />,
}));


const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
};

const container = document.getElementById("root");
const root = createRoot(container);


root.render(
	<Root>
			<BrowserRouter>
				<React.Fragment>
					<Routes>
						{/* <Route element={ScrollToTop} /> */}

						{/* <Route  strict  path="/:url*" render={props => <Redirect to={`${props.location.pathname}/`} />} /> */}
						<Route index path={"/"}  element={<App />} />
						<Route element={<IFrame />} path={'/messages'} />
						<Route element={<IFrame />} path={'/messages/thread/new'} />
						<Route element={<IFrame />} path={'/messages/thread/:id'} />
						
						{/* Test Routes*/}
						{/* <Route path={"/saurabh/test"}  element={TestComponent} /> */}

						<Route path={"/search-location"}  element={<Location />} />
						<Route path={"/my-location"}  element={<GeoLocationPage />} />
						<Route path={"/my-card"}  element={<CreditCardPage />} />

						<Route path={"/categories/stores"}  element={<RestaurantListOnCategory />} />

						{/* <Route path={"/stores/:restaurant"}  element={<Items />} /> */}
						<Route path={"/stores/:restaurant"}  element={<ItemsParent />} />
						{/* <Route path={"/stores/:restaurant/:id"}  element={<SingleItem />} /> */}
						<Route path={"/stores/:restaurant/:id"}  element={<SingleItemParent />} />


						{/* <Route path={"/player"}  element={<Player />} /> */}

						<Route path={"login/*"} element={<Login />} >
							<Route path={"forgot-password"} element={<ForgotPassword />} />
						</Route>
						
						<Route path={"register"} element={<Register />} />


						<Route element={<App />}>
						<Route index element={<Home />} />
						<Route path="/explore" element={<Explore />} />
						<Route path="/cart" element={<CartPage />} />
						<Route path="/my-carts" element={<MyCarts />} />
						<Route path="/alerts" element={<Alerts />} />
						<Route path="/my-account" element={<Account />} />
						</Route>
						<Route path={"/my-addresses"}  element={<Addresses />} />
						<Route path={"/my-cards"}  element={<Cards />} />

						<Route path={"/my-wallet"}  element={<WalletPage />} />
						<Route path={"/my-orders"}  element={<Orders />} />
						<Route path={"/rate-and-review/:id"}  element={<RatingAndReview />} />
						<Route path={"/rate-order/:id"}  element={<RatingAndReview />} />
						<Route path={"/reviews/:slug"}  element={<ViewStoreReviews />} />

						<Route path={"/checkout"}  element={<Checkout />} />
						<Route path={"/running-order/:unique_order_id"}  element={<RunningOrder />} />
						


						<Route path={"/pages/:slug"}  element={<SinglePage />} />
						<Route path={"/my-favorite-stores"}  element={<FavoriteRestaurantList />} />
						
						<Route path={"/auth/login-as-customer/:id"}  element={<LoginAsCustomer />} />
						<Route path="/auth/login-as-customer" element={<LoginAsCustomer />} />


						{/* Delivery Routes */}
						<Route path={"/delivery"}  element={<Delivery />} />
						<Route path={"/delivery/login"}  element={<DeliveryLogin />} />
						<Route path={"/delivery/orders"}  element={<DeliveryOrders />} />
						<Route path={"/delivery/orders/:unique_order_id"}  element={<ViewOrder />} />
						<Route path={"/delivery/completed-orders"}  element={<Delivery />} />

						{/* POS Routes */}
						<Route path={"/pos/*"}  element={<POS />} />

						{/* Table booking (customer) */}
						<Route path={"/book-table/:id"}  element={<BookTable />} />
						{/* Table QR scan → dine-in landing */}
						<Route path={"/t/:token"}  element={<TableLanding />} />

						{/* <Route path={"/my-spot-orders"}  element={<SpotOrders />} /> */}
						{/* <Route path={"/stores/:restaurant"}  element={<SpotsParent />} /> */}
						{/* <Route path={"/stores/:restaurant/:id"}  element={<SingleSpotParent />} /> */}
						{/* <Route path={"/running-order/:unique_spotorder_id"}  element={<RunningSpotOrder />} /> */}


						{/* Common Routes */}
						<Route element={<NotFound />} />
					</Routes>
				</React.Fragment>
			</BrowserRouter>
	</Root>
);
